import { canUseEventBridge, currentDrift, round, timeStampNow } from '@openobserve/browser-core';
export function startDefaultContext(hooks, configuration, sdkName) {
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => {
        const source = configuration.source;
        return {
            type: eventType,
            _oo: {
                format_version: 2,
                drift: currentDrift(),
                configuration: {
                    session_sample_rate: round(configuration.sessionSampleRate, 3),
                    session_replay_sample_rate: round(configuration.sessionReplaySampleRate, 3),
                    profiling_sample_rate: round(configuration.profilingSampleRate, 3),
                    trace_sample_rate: round(configuration.traceSampleRate, 3),
                    beta_encode_cookie_options: configuration.betaEncodeCookieOptions,
                },
                browser_sdk_version: canUseEventBridge() ? "0.3.1" : undefined,
                sdk_name: sdkName,
            },
            application: {
                id: configuration.applicationId,
            },
            date: timeStampNow(),
            source,
        };
    });
    hooks.register(1 /* HookNames.AssembleTelemetry */, () => ({
        application: { id: configuration.applicationId },
    }));
}
//# sourceMappingURL=defaultContext.js.map